import { FormGroup, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { post, put } from 'helpers/api';
import ErrorAlert from '../../../project/components/new_listing_modal/error_alert';
import { specialtyPropertyTypesPropTypes } from './index';
import Button from 'shared/button';

function initialPropertyType({ propertyType, specialtyPropertyTypes }) {
  if (propertyType) {
    const propTypeObject = specialtyPropertyTypes.find(propTypes => propTypes.label === propertyType);
    if (propTypeObject) {
      return propTypeObject.value;
    }
  }

  return specialtyPropertyTypes[0].value;
}

export default function EditModal(props) {
  const [title, setTitle] = useState(props.title || '');
  const [propertyType, setPropertyType] = useState(() => initialPropertyType(props));
  const [errors, setErrors] = useState([]);
  const [isSubmitted, setIsSubmitting] = useState(false);

  const canSubmitForm = title.length > 0 && propertyType.length > 0;

  async function submitForm(e) {
    e.preventDefault();

    if (!canSubmitForm) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    const { fetchMethod, url } = fetchParams();
    try {
      const brokerSpecialtyArguments = { title };
      if (props.groupSpecialties) {
        brokerSpecialtyArguments.propertyType = propertyType;
      }
      const res = await fetchMethod(url, { broker_specialty: brokerSpecialtyArguments });
      setIsSubmitting(false);
      if (res.id) {
        props.onSuccessfulFormSubmit(res);
      } else {
        setErrors(res);
      }
    } catch {
      setIsSubmitting(false);
      const uploadType = props.id === '' ? 'created' : 'updated';
      setErrors([`Specialty could not be ${uploadType}. Please try again or contact support for help.`]);
    }
  }

  function fetchParams() {
    if (props.id === '') {
      return { fetchMethod: post, url: '/broker_specialties' };
    }

    return { fetchMethod: put, url: `/broker_specialties/${props.id}` };
  }

  return (
    <Modal.Body className="p-5">
      <h2 className="text-center mt-0 mb-4">{props.id === '' ? 'Add a' : 'Edit'} Specialty</h2>
      <ErrorAlert errorMessages={errors} hasErrors={errors.length > 0}/>
      <form onSubmit={submitForm}>
        <FormGroup>
          <label htmlFor="specialty-initials">Add Specialty Initials</label>
          <input
            autoFocus
            className="form-control"
            id="specialty-initials"
            placeholder="Enter specialty title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </FormGroup>

        {props.groupSpecialties && (
          <FormGroup>
            <label htmlFor="specialty-availablity">Availability</label>
            <select
              className="form-control"
              id="specialty-availablity"
              value={propertyType}
              onChange={e => setPropertyType(e.target.value)}
            >
              {props.specialtyPropertyTypes.map(propType => (
                <option key={propType.value} value={propType.value}>{propType.label}</option>
              ))}
            </select>
          </FormGroup>
        )}

        <div className="mt-5 d-flex gap-3">
          <Button.Cancel
            disabled={isSubmitted}
            type="button"
            onClick={props.onCloseModal}
          >
            Cancel
          </Button.Cancel>
          <Button.Primary disabled={!canSubmitForm || isSubmitted} type="submit">
            {props.id === '' ? 'Add' : 'Update'} Specialty
          </Button.Primary>
        </div>
      </form>
    </Modal.Body>
  );
}

EditModal.propTypes = {
  ...specialtyPropertyTypesPropTypes,
  groupSpecialties: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  propertyType: PropTypes.string,
  title: PropTypes.string,
  onCloseModal: PropTypes.func.isRequired,
  onSuccessfulFormSubmit: PropTypes.func.isRequired,
};